import { TUserGroups } from "../types";

export const removeLeadingSlash = (str: string): string =>
  str?.replace(/^\/+/, "");

export const getFilteredLinks = (
  links: TUserGroups[],
  visibleLinks: string[],
): string[] => {
  return links?.filter(
    (link) =>
      !visibleLinks?.includes(link) && link !== "/settings" && link !== "/krab",
  );
};
